import { Avatar, Select, styled, TextField } from '@mui/material';
import { cn } from '@tempo-io/sui-class-utils';
import { type ComponentProps } from 'react';
import Dot from './icons/Dot';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const CommentInputContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: theme.spacing(0.5),
  border: `1px solid ${theme.palette.divider}`,
  '&:hover': {
    border: `1px solid ${theme.palette.text.secondary}`,
  },
  padding: theme.spacing(0.5),
}));

export const StyledTextField = styled(TextField)(() => ({
  '&:hover': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'transparent',
    },
  },
  '& .Mui-focused': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'transparent',
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent',
  },
}));

export const ButtonBar = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  paddingTop: theme.spacing(0.5),
  alignItems: 'center',
}));

export const Comment = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(0.5),
  borderRadius: theme.spacing(0.5),
  '& .MuiIconButton-root': {
    opacity: 0,
  },
  '&:hover': {
    '& .MuiIconButton-root': {
      opacity: 1,
    },
  },
}));

export const CommentHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center',
  position: 'relative',
}));

export function Name({ className, ...props }: ComponentProps<'span'>) {
  return <span className={cn('text-sm leading-normal font-semibold', className)} {...props} />;
}

export const StyledAvatar = styled(Avatar)(() => ({
  bgcolor: 'teal',
  width: 24,
  height: 24,
  fontSize: '.875rem',
}));

export function SubText({ className, ...props }: ComponentProps<'span'>) {
  return <span className={cn('text-xs leading-relaxed font-semibold text-text-neutral-secondary', className)} {...props} />;
}

export const StyledDot = styled(Dot)(() => ({
  fontSize: 4,
}));

export const InternalSelect = styled(Select)(({ theme }) => ({
  '& .MuiSelect-select': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent',
  },
  '& svg': {
    color: theme.palette.primary.main,
  },
}));

export const InlineInternalSelect = styled(Select)(({ theme }) => ({
  position: 'absolute',
  right: 0,
  top: 0,
  '& .MuiSelect-select': {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    // textTransform: 'uppercase',
    fontSize: 12,
    // color: theme.palette.primary.main,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent',
  },
  '& svg': {
    opacity: 0,
    fontSize: 16,
    // color: theme.palette.primary.main,
  },
  '&:hover': {
    '& svg': {
      opacity: 1,
    },
  },
}));
